import axios from "axios";

export const API_URL = "https://api.pawplaylove.com/api/";
export const contactUsApi = (formData) =>
  axios.post(`${API_URL}contactus/contact-us-web`, formData);
